import type { Branded } from "@@/utilities/branded";
import { genericId } from "@@/utilities/generic-id";

const { zodSchema: newsLetterIdZodSchema } = genericId<NewsletterId>(
    "newsletter__",
    {
        regexMatch: /(^newsletter_.*$)/,
    },
);

type NewsletterId = Branded<string, "NewsletterId">;
/**
 * @param {string} newsletterSlug MUST BE AT LEAST 5 CHARS LONG
 * @returns {NewsletterId}
 */
const getNewsletterId = (newsletterSlug: string): NewsletterId => {
    if (newsletterSlug.trim().length < 4)
        throw new Error("Slug must be at least 4 chars long");
    const id = `newsletter__${newsletterSlug}` as NewsletterId;
    const valid = newsLetterIdZodSchema.safeParse(id).success;
    if (!valid)
        throw new Error(
            "Failed to create newsletter id with slug: " + newsletterSlug,
        );
    return id;
};

export { getNewsletterId, newsLetterIdZodSchema };
export type { NewsletterId };
